import { Menu } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => Menu,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.Menu) =>
    kontentAiDataMapping.menu(entry),
  depthParameter: 4,
};
